import React from "react";

export default React.createContext({
    language: "ro",
    setLanguage: () => {},
});